module.exports = __webpack_public_path__ + "img/blocks_active.08eaf91a.svg";